import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const Wrapper = styled.div `
  .btn {
    margin-top: 3rem;
  }
  
  .section__title {
    margin-bottom: 0;
  }
  
  .section__copy {
    margin: 0.5rem 0 0;
  }
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    .btn {
      margin-top: 1.5rem;
    }
  }
`;
export default {
    Wrapper,
};
